import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RulesService } from 'app/services/audit/rules.service';
import { MessageService , SelectItem} from 'primeng/primeng';
import { AuditConditionForm } from 'app/views/audit/models/audit-condition.model';
import { AuditRuleCondition as AuditRuleCondition, AuditRuleDtl, AuditRuleObject, AuditRulesConditionType, AuditRulesType, JsonSchema } from 'app/views/audit/models/audit-event.model';
import { AcmTypeHasReasonService } from 'app/services/loyalty/acm-type-has-reason.service';
import { Acm } from 'app/models/loyalty-acm.model';
import { Moment } from 'moment';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { AcmTypehasReason } from 'app/models/loyalty-acm-type.model';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { PromotionOchannelService } from 'app/services/promotion/promotion-ochannel.service';

@Component({
  selector: 'app-audit-new-condition',
  templateUrl: './audit-new-condition.component.html',
  styleUrls: ['./audit-new-condition.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuditNewConditionComponent implements OnInit {
  ruleConditionIdCombo: AuditRuleCondition = new AuditRuleCondition(); 
  errors: boolean = false;
  @Input() ui_mode: string = this.rulesService.ui_modes.CREATE;
  @Input() formSchema: any;
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() schemaMode: string = this.rulesService.schema_modes.CREATE;
  @Input() clusterOption: SelectItem[];
  @Input() clusterOptionActive: SelectItem[];
  @Input() acmList: SelectItem[];
  @Input() acmListFull: Array<Acm>;
  @Input() backButton: boolean = true;
  @Input() isPopUp: boolean ;
  @Input() auditRuleObject: AuditRuleObject;
  @Output() forwardButtonClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() enableConfirmButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formSchemaChanged: EventEmitter<JsonSchema> = new EventEmitter<JsonSchema>();
  @Output() conditionChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() closePopUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() conditionObjectChanged: EventEmitter<AuditRuleObject> = new EventEmitter<AuditRuleObject>();
  @ViewChild('condition_notes') condition_notes: FormFields;
  @ViewChild('condition_table_ref') condition_table_ref: FormFields;
  @ViewChild('cluster') cluster: FormFields; 
  @ViewChild('acm') acm: FormFields;
  @ViewChild('acm_reason') acm_reason: FormFields;
  @ViewChild('condition_code') condition_code: FormFields;
  @ViewChild('condition_description') condition_description: FormFields;
  @ViewChild('acm_min') acm_min: FormFields;
  @ViewChild('acm_max') acm_max: FormFields;
  @ViewChild('acm_range') acm_range: FormFields;
  @ViewChild('acm_value') acm_value: FormFields;
  @ViewChild('touchpoint') touchpoint: FormFields;
  @ViewChild('source_system') source_system: FormFields;
  @ViewChild('condition_type') condition_type: FormFields;
  @ViewChild('condition_source') condition_source: FormFields;
  @ViewChild('acm_comparison_operator') acm_comparison_operator: FormFields;
  @ViewChild('cluster_boolean_condition') cluster_boolean_condition: FormFields;
  @ViewChild('conditionListTable') conditionListTable: Campaign3KontableComponent;
  @Input() listReasonsFull: Array<AcmTypehasReason> = [];
  @Input() auditRuleConditionEditId: number;
  formGroup: FormGroup;
  @Input() touchpointOption: SelectItem[] = [];
  @Input() sourceSystemOption: SelectItem[] = [];
  @Input() listReasonsFiltered: SelectItem[] = [];
  conditionForm: AuditConditionForm = new AuditConditionForm();
  selectedRuleCondition : any = null; 
  @Input() selectedOperatorBooleanCondition: string;
  @Input() ruleId: number;
  conditionTableRef: any;
  fieldModel = {
    cluster: null,
    acm: null,
    acm_reason: null,
    condition_notes: null,
    condition_code: null,
    condition_description: null,
    acm_min: null,
    acm_max: null,
    acm_range: null,
    acm_value: null,
    touchpoint: null,
    source_system: null,
    condition_type: null,
    condition_source: null,
    acm_comparison_operator: null,
    cluster_boolean_condition: null,
    condition_table_ref: null,

  }

  ready = {
    form: false
  }

  show = {
    touchpointShow: false,
    form: false,
    cluster: false,
    acm: false,
    acm_reason: false,
    condition_notes: false,
    source_system: false,

  }

  @Input() conditionsType: Array<AuditRulesConditionType>;
  @Input() conditionsTypeCombo: SelectItem[];

  constructor(
    private srvTranslate: TranslateService,
    private srvMessage: MessageService,
    public rulesService: RulesService,
    private translate: TranslateService,
    private acmTypeHasReasonService: AcmTypeHasReasonService,
    private fb: FormBuilder
    ) {
  }

  ngOnInit() {
    this.initForm();
    this.show.form = true;
    if(this.auditRuleConditionEditId && this.auditRuleConditionEditId > 0){
      this.ui_mode = this.rulesService.ui_modes.EDIT   
      this.setFormField();
    }else{
      this.ui_mode = this.rulesService.ui_modes.CREATE
      this.selectedRuleCondition = null;
      this.fieldModel.acm = null;
      this.fieldModel.acm_reason = null;
      this.fieldModel.cluster = null;
      this.fieldModel.condition_notes = null;
      this.fieldModel.condition_code = null;
      this.fieldModel.condition_description = null;
      this.fieldModel.acm_min = null;
      this.fieldModel.acm_max = null;
      this.fieldModel.acm_range = null;
      this.fieldModel.acm_value = null;
      this.fieldModel.touchpoint = null;
      this.fieldModel.source_system = null;
      this.fieldModel.condition_type = null;
      this.fieldModel.condition_source = null;
      this.fieldModel.acm_comparison_operator = null;
      this.fieldModel.cluster_boolean_condition = null;

    }
    
  }

  onClickExists() {
    this.enableConfirmButton.emit(true);

  }
  
  performValidationCondition(): boolean {
    this.conditionForm.valid = true;

    // Check selectedRuleCondition
    if (KoncentroValidators.isEmptyInputValue(this.selectedRuleCondition)) {
      this.conditionForm.valid = false;
      const errorTitle = this.translate.instant('common.error');
      const errorDetail = this.translate.instant('common.empty_fields');
      this.srvMessage.add({
        severity: 'error',
        summary: errorTitle,
        detail: errorDetail
      });
    }

    // Block save if condition type selected but no schema loaded from DB
    if (this.selectedRuleCondition && !this.formSchema) {
      this.conditionForm.valid = false;
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('common.no_template_schema')
      });
    }

    // Lista dei controlli da validare condizionatamente
    const controlsToValidate = [
      { show: this.show.acm, control: this.acm },
      { show: this.show.cluster, control: this.cluster },
      { show: this.show.source_system, control: this.source_system },
      { show: this.show.touchpointShow, control: this.touchpoint },
      { show: this.show.acm_reason, control: this.acm_reason },
      { show: true, control: this.condition_code },
      { show: true, control: this.condition_description }


    ];
  
    controlsToValidate.forEach(item => {
      if (item.show && item.control) {
        if (typeof item.control.performValidation === 'function') {
          item.control.performValidation();
        }
        if (item.control.valid === false) {
          this.conditionForm.valid = false;
        }
      }
    });

    if (this.show.cluster) {
      const clusterItem = this.fieldModel.cluster as any;
      if (clusterItem && clusterItem.date_end) {
        const dateEnd = new Date(clusterItem.date_end);
        dateEnd.setHours(23, 59, 59, 999);
        if (dateEnd < new Date()) {
          this.conditionForm.valid = false;
          this.srvMessage.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('audit.cluster_expired')
          });
        }
      }
    }

    return this.conditionForm.valid;
  }
  
  

  loadJsonSchema(typeCondition: SelectItem, appTypeConditionFull?: AuditRulesConditionType){
    this.formSchema = null;
    this.show.condition_notes = false;
    this.show.cluster = false;
    this.show.acm = false;
    this.show.acm_reason = false;
    this.show.touchpointShow = false;
    this.show.source_system = false;
    var conditionRuleTypeIndex = this.conditionsType.findIndex(f => f.id === typeCondition.value);
    this.rulesService.getJsonFormSchema('condition', this.ui_mode, typeCondition.value).subscribe(resSchema => {
      if (resSchema ) {
        var self = this;
        this.rulesService.getTemplateById(resSchema.template_id).subscribe(resTemplate => {
          if(resTemplate){
            var newSchema = this.rulesService.getPreparedFormSchemasConditions(resTemplate);
            setTimeout(function () {
              self.formSchema = newSchema.properties.condition;
              newSchema.mode = self.schemaMode;
              self.formSchemaChanged.emit(newSchema);
              var self2 = self;
              console.log(self.formSchema);
              setTimeout(function () {
                //self2.ready.form = true;
                //self2.enableConfirmButton.emit(true);
               
                let abc = self2.conditionsType[conditionRuleTypeIndex];
                self2.conditionTableRef = abc.condition_table_ref;

                if( self2.formSchema && self2.formSchema.form && self2.formSchema.form.condition_notes)
                  self2.show.condition_notes = true;
                if (abc.code === "cluster") {
                  self2.show.cluster = true;
                  self2.show.acm = false;
                  self2.show.touchpointShow = false;
                  self2.show.acm_reason = false;
                  self2.show.source_system = false;
                  if(appTypeConditionFull){ //spostato qui per problemi di rendering
                    self2.setFormFieldAfterLoadJson(typeCondition, appTypeConditionFull);
                  }
                } else if (abc.code === "touchpoint") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.touchpointShow = true;
                  self2.show.acm_reason = false;
                  self2.show.source_system = false;
                  //self2.touchpointOption.push({label: self2.translate.instant('common.select_something'), value: null });
                  if(appTypeConditionFull){ //spostato qui per problemi di rendering
                    self2.setFormFieldAfterLoadJson(typeCondition, appTypeConditionFull);
                  }
                } else if (abc.code === "source_system") {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.touchpointShow = false;
                  self2.show.acm_reason = false;
                  self2.show.source_system = true;
                  if(appTypeConditionFull){
                    self2.setFormFieldAfterLoadJson(typeCondition, appTypeConditionFull);
                  }
                } else if (abc.code === "movement") {//alias acm_reason nel json form di audit.audit_template
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.acm_reason = true;
                  self2.show.touchpointShow = false;
                  self2.show.source_system = false;
                  if(appTypeConditionFull){ //spostato qui per problemi di rendering
                    self2.setFormFieldAfterLoadJson(typeCondition, appTypeConditionFull);
                  }
                } else if (abc.code === "acm") {
                  self2.show.cluster = false;
                  self2.show.acm = true;
                  self2.show.acm_reason = false;
                  self2.show.touchpointShow = false;
                  self2.show.source_system = false;
                  if(appTypeConditionFull){ //spostato qui per problemi di rendering
                    self2.setFormFieldAfterLoadJson(typeCondition, appTypeConditionFull);
                  }
                } else  {
                  self2.show.cluster = false;
                  self2.show.acm = false;
                  self2.show.acm_reason = false;
                  self2.show.touchpointShow = false;
                  self2.show.source_system = false;
                  self2.show.condition_notes = false;
                  self2.formSchema = null;
                  self2.srvMessage.add({
                    severity: 'error',
                    summary: self2.translate.instant('common.error'),
                    detail: self2.translate.instant('common.no_template_schema')
                  });
                }

              }, 100)
            }, 100);
          }else {
            this.formSchemaChanged.emit(null);
            this.srvMessage.add({
              severity: 'error',
              summary: this.translate.instant('common.error'),
              detail: this.translate.instant('common.no_template_schema')
            });
          }
       });
      }
      else {
        //caso non viene restituito schema, devi fermarti (da gestire)!
        this.formSchemaChanged.emit(null);
        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('common.no_template_schema')
        });
      }
    });
  }

  async validaForms() {

    let validationCondition = await this.performValidationCondition();
    if (!validationCondition) {
      return;
    }
    //se tutto è giusto procedi al salvataggio
    this.saveAuditRuleInstanceObject();
  }
 
  performSaveNewAuditRuleConditionInstance() {
    this.rulesService.saveAuditRuleGlobalObject(this.auditRuleObject).subscribe(res => {
      if (res) {
        this.auditRuleObject = res;
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.closePopUpDialog();
      } else {
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericConditionError')
        });
        this.closePopUpDialog();
      }
    }, error => {
      console.error("errore aggiunta dettagolio regola")
      this.auditRuleObject.auditRuleCondition.pop(); 
      this.closePopUpDialog();
    });

  }

  performUpdateAuditRuleConditionInstance() {
    this.rulesService.updateAuditRuleGlobalObject(this.auditRuleObject).subscribe(res => {

      if (res) {
    //self.ui_mode.infoBase = this.rulesService.ui_modes.EDIT;
       // self.conditionListTable.refresh();
       this.auditRuleObject = res;
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.closePopUpDialog();
      } else {
        this.auditRuleObject.auditRuleCondition.pop();
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericConditionError')
        });
        this.closePopUpDialog();

      }
    }, error => {
      console.error("errore aggiunta dettagolio regola")
      this.auditRuleObject.auditRuleCondition.pop(); 
      this.closePopUpDialog();
    });

  }
  updateAuditRuleGlobalObject() {
    //fix perchè be manda oggetto nella get dell'oggettone
    this.auditRuleObject.auditRuleDtl.forEach(element => {
      if(element.audit_action_type_id &&  element.audit_action_type_id.id){
        let app: any = element.audit_action_type_id.id;
        element.audit_action_type_id = app;
      }
    })

    this.auditRuleObject.auditRuleCondition.forEach(element => {
      if(element.audit_rules_condition_type_id &&  element.audit_rules_condition_type_id.id){
        let app: any = element.audit_rules_condition_type_id.id;
        element.audit_rules_condition_type_id = app;
      }
    })

    this.ruleConditionIdCombo.description = this.fieldModel.condition_description;
    this.ruleConditionIdCombo.code = this.fieldModel.condition_code;
    this.ruleConditionIdCombo.audit_rules_condition_type_id = this.selectedRuleCondition;
    if(this.show.acm){
      this.ruleConditionIdCombo.condition_entity_id = this.fieldModel.acm.value;
      this.ruleConditionIdCombo.acm_range = this.fieldModel.acm_range;
      if(this.fieldModel.acm_range){
        this.ruleConditionIdCombo.min_range_value = this.fieldModel.acm_min;
        this.ruleConditionIdCombo.max_range_value = this.fieldModel.acm_max;
      }else{
        if(this.fieldModel.acm_comparison_operator == ">=")
          this.ruleConditionIdCombo.min_range_value = this.fieldModel.acm_value;
        else
        this.ruleConditionIdCombo.max_range_value = this.fieldModel.acm_value;
      }
    }else if(this.show.cluster){
      this.ruleConditionIdCombo.condition_entity_id = this.fieldModel.cluster.value;
      this.ruleConditionIdCombo.flg_boolean_condition = this.fieldModel.cluster_boolean_condition.value;
    }else if(this.show.touchpointShow){
      this.ruleConditionIdCombo.condition_entity_id = this.fieldModel.touchpoint.value;
    }else if(this.show.source_system){
      this.ruleConditionIdCombo.condition_entity_id = this.fieldModel.source_system.value;
    }else if(this.show.acm_reason){
      this.ruleConditionIdCombo.condition_entity_id = this.fieldModel.acm.value;
      this.ruleConditionIdCombo.reason_condition_id = this.fieldModel.acm_reason.value;
      this.ruleConditionIdCombo.acm_range = this.fieldModel.acm_range;
      if(this.fieldModel.acm_range){
        this.ruleConditionIdCombo.min_range_value = this.fieldModel.acm_min;
        this.ruleConditionIdCombo.max_range_value = this.fieldModel.acm_max;
      }else{
        if(this.fieldModel.acm_comparison_operator == ">=")
          this.ruleConditionIdCombo.min_range_value = this.fieldModel.acm_value;
        else
        this.ruleConditionIdCombo.max_range_value = this.fieldModel.acm_value;
      }
    }else{
      //caso in cui non abbiamo messo condition type...possibile?
      //se non possibile bisogna bloccare o quanto meno disabilitare il bottone salva
      this.formSchemaChanged.emit(null);
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.noDetailsCompiled')
      });
      return;
    }
    this.auditRuleObject.rule.conditionBooleanOperator = this.selectedOperatorBooleanCondition;
    const index = this.auditRuleObject.auditRuleCondition.findIndex(item => item.id === this.ruleConditionIdCombo.id);
    if (index !== -1) {
       this.auditRuleObject.auditRuleCondition[index] = this.ruleConditionIdCombo; // Assign a new value to the found index
    }   
  }


  saveNewAuditRuleGlobalObject() {
    this.auditRuleObject.auditRuleDtl.forEach(element => {
      if(element.audit_action_type_id &&  element.audit_action_type_id.id){
        let app: any = element.audit_action_type_id.id;
        element.audit_action_type_id = app;
      }
    })

    this.auditRuleObject.auditRuleCondition.forEach(element => {
      if(element.audit_rules_condition_type_id &&  element.audit_rules_condition_type_id.id){
        let app: any = element.audit_rules_condition_type_id.id;
        element.audit_rules_condition_type_id = app;
      }
    })


    let appRuleCondition = new AuditRuleCondition();

    appRuleCondition.audit_rule_id = this.auditRuleObject.rule.id; 
    appRuleCondition.description = this.fieldModel.condition_description;
    appRuleCondition.code = this.fieldModel.condition_code;
    appRuleCondition.audit_rules_condition_type_id = this.selectedRuleCondition;

    if(this.show.acm){
      appRuleCondition.condition_entity_id = this.fieldModel.acm.value;
      appRuleCondition.acm_range = this.fieldModel.acm_range;
      if(this.fieldModel.acm_range){
        appRuleCondition.min_range_value = this.fieldModel.acm_min;
        appRuleCondition.max_range_value = this.fieldModel.acm_max;
      }else{
        if(this.fieldModel.acm_comparison_operator == ">=")
          appRuleCondition.min_range_value = this.fieldModel.acm_value;
        else
          appRuleCondition.max_range_value = this.fieldModel.acm_value;
      }
    }else if(this.show.cluster){
      appRuleCondition.condition_entity_id = this.fieldModel.cluster.value;
      appRuleCondition.flg_boolean_condition = this.fieldModel.cluster_boolean_condition.value;
    }else if(this.show.touchpointShow){
      appRuleCondition.condition_entity_id = this.fieldModel.touchpoint.value;
    }else if(this.show.source_system){
      appRuleCondition.condition_entity_id = this.fieldModel.source_system.value;
    }else if(this.show.acm_reason){
      appRuleCondition.condition_entity_id = this.fieldModel.acm.value;
      appRuleCondition.reason_condition_id = this.fieldModel.acm_reason.value;
      appRuleCondition.acm_range = this.fieldModel.acm_range;
      if(this.fieldModel.acm_range){
        appRuleCondition.min_range_value = this.fieldModel.acm_min;
        appRuleCondition.max_range_value = this.fieldModel.acm_max;
      }else{
        if(this.fieldModel.acm_comparison_operator == ">=")
          appRuleCondition.min_range_value = this.fieldModel.acm_value;
        else
          appRuleCondition.max_range_value = this.fieldModel.acm_value;
      }
    }else{
      //caso in cui non abbiamo messo condition type...possibile?
      //se non possibile bisogna bloccare o quanto meno disabilitare il bottone salva
      this.formSchemaChanged.emit(null);
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.noDetailsCompiled')
      });
      return;
    }
    this.auditRuleObject.rule.conditionBooleanOperator = this.selectedOperatorBooleanCondition;
    this.auditRuleObject.auditRuleCondition.push(appRuleCondition);
  }


 saveAuditRuleInstanceObject() {

 
      //elaboro la condizione se devo crearla o andare in update
      if(this.auditRuleConditionEditId && this.auditRuleConditionEditId > 0){
        this.updateAuditRuleGlobalObject();
      }else{
        this.saveNewAuditRuleGlobalObject();
      }

      //dopo aver salvato la condizione, verifico se devo creare la nuova regola o andare in update
      if(this.auditRuleObject && this.auditRuleObject.rule && this.auditRuleObject.rule.id){
        this.performUpdateAuditRuleConditionInstance();
      }else{
        this.performSaveNewAuditRuleConditionInstance();
      }
  }

  addNewCondition() {
    this.validaForms();
  }

  onClickClose() {
    if(this.isPopUp){
      this.isPopUp = false;
      this.closePopUp.emit();
    }
  }
 
  onChangeAcm(acm: SelectItem, ruleTable?: AuditRuleCondition) {
    // Svuota la lista prima di popolarla
    this.listReasonsFiltered = [];
    //this.listReasonsFiltered.push({ value: null, label: 'null' });

    const params = [{ key: 'limit', value: '9999999' }];
    params.push({ key: 'flg_state', value: '0' });
    const acmItem = this.acmListFull.find((f) => f.id === acm.value);
    let acmTypeId = acmItem ? acmItem.acm_type_id : undefined;
    if(acmTypeId){
      this.acmTypeHasReasonService.getFromAcmType(acmTypeId, params).subscribe(resp => {
          // Controlla se ci sono dati nella risposta
          if (resp.data && resp.data.length > 0) {
              for (const reason of resp.data) {
                  this.listReasonsFiltered.push({
                      value: reason.reason_id,
                      label: reason.reasonCode + " | " + reason.reasonDescription
                  });
              }
              var self = this;
              setTimeout(function() {

                if(ruleTable){
                  self.fieldModel.acm = acm;
                    self.fieldModel.acm_reason = self.listReasonsFiltered.find(f => f.value === ruleTable.reason_condition_id); //ruleTable.reason_id;
                }
              }, 100)
          }
          // Log per verificare se la lista è stata aggiornata correttamente
          console.log(this.listReasonsFiltered);
      });
    }
  }

  initForm() {
    this.formGroup = this.fb.group({
      date_end: [null, Validators.required],
      date_start: [null, Validators.required]    });
  }

  setFormField() {
    this.ruleConditionIdCombo = this.auditRuleObject.auditRuleCondition.find(f => f.id === this.auditRuleConditionEditId);
    let appTypeCondition : SelectItem;
    let appTypeConditionFull: AuditRulesConditionType;
    if(this.ruleConditionIdCombo.audit_rules_condition_type_id && this.ruleConditionIdCombo.audit_rules_condition_type_id.id){
      //caso di edit e sono nel primo salvataggio partendo dalle regole mi arriva un oggetto AuditRuleCondition e non l'id
      appTypeCondition =  this.conditionsTypeCombo.find(f => f.value === this.ruleConditionIdCombo.audit_rules_condition_type_id.id);
      appTypeConditionFull =  this.conditionsType.find(f => f.id === (this.ruleConditionIdCombo.audit_rules_condition_type_id.id));
    }else{
      appTypeCondition =  this.conditionsTypeCombo.find(f => f.value === this.ruleConditionIdCombo.audit_rules_condition_type_id);
      appTypeConditionFull =  this.conditionsType.find(f => f.id === (this.ruleConditionIdCombo.audit_rules_condition_type_id as any));
    }
    
    this.loadJsonSchema(appTypeCondition, appTypeConditionFull);
  }

  private setFormFieldAfterLoadJson(appTypeCondition: SelectItem, appTypeConditionFull: AuditRulesConditionType) {
    let ruleTable = this.auditRuleObject.auditRuleCondition.find(f => f.id === this.auditRuleConditionEditId);
    this.fieldModel.condition_description = ruleTable.description;
    this.fieldModel.condition_code = ruleTable.code;
    this.selectedRuleCondition = appTypeCondition.value;
    var self = this;
    setTimeout(function () {
      
      if (appTypeConditionFull.code === "acm") {
        self.onChangeAcm(self.acmList.find(f => f.value === ruleTable.condition_entity_id), ruleTable); //ruleTable.acm_id;
        self.fieldModel.acm = self.acmList.find(f => f.value === ruleTable.condition_entity_id);
        if(ruleTable.max_range_value){
          if(ruleTable.max_range_value){
            self.fieldModel.acm_range = true;
            self.fieldModel.acm_max = ruleTable.max_range_value;
            self.fieldModel.acm_min = ruleTable.min_range_value;
          }else{
            self.fieldModel.acm_range = false;
            self.fieldModel.acm_value = ruleTable.min_range_value;
            self.fieldModel.acm_comparison_operator = self.formSchema.form.acm_comparison_operator[1];
          }
        }else{
          if(ruleTable.max_range_value){
            self.fieldModel.acm_range = false;
            self.fieldModel.acm_value = ruleTable.max_range_value;
            self.fieldModel.acm_comparison_operator = self.formSchema.form.acm_comparison_operator[0];
          }
        }

      }

      if (appTypeConditionFull.code === "cluster") {//clusterid
        self.fieldModel.cluster = self.clusterOption.find(f => f.value == ruleTable.condition_entity_id);
        self.fieldModel.cluster_boolean_condition = {label:self.formSchema.form.cluster_boolean_condition.options.find(
          f => f.value == ruleTable.flg_boolean_condition).label.it, value:ruleTable.flg_boolean_condition};
      }
      
      if (appTypeConditionFull.code === "touchpoint") {//clusterid
        self.fieldModel.touchpoint = self.touchpointOption.find(f => f.value == ruleTable.condition_entity_id);
      }

      if (appTypeConditionFull.code === "source_system") {//clusterid
        self.fieldModel.source_system = self.sourceSystemOption.find(f => f.value == ruleTable.condition_entity_id);
      }

      if (appTypeConditionFull.code === "movement") {
        self.onChangeAcm(self.acmList.find(f => f.value === ruleTable.condition_entity_id), ruleTable); //ruleTable.acm_id;
        self.fieldModel.acm = self.acmList.find(f => f.value === ruleTable.condition_entity_id);
        //self.fieldModel.acm_reason = self.listReasonsFull.find(f => f.acm_type_id === ruleTable.condition_entity_id);
        //TODO verificare dove mettere le reason
        if(ruleTable.max_range_value){
          if(ruleTable.max_range_value){
            self.fieldModel.acm_range = true;
            self.fieldModel.acm_max = ruleTable.max_range_value;
            self.fieldModel.acm_min = ruleTable.min_range_value;
          }else{
            self.fieldModel.acm_range = false;
            self.fieldModel.acm_value = ruleTable.min_range_value;
            self.fieldModel.acm_comparison_operator = self.formSchema.form.acm_comparison_operator[1];
          }
        }else{
          if(ruleTable.max_range_value){
            self.fieldModel.acm_range = false;
            self.fieldModel.acm_value = ruleTable.max_range_value;
            self.fieldModel.acm_comparison_operator = self.formSchema.form.acm_comparison_operator[0];
          }
        }

      }

    }, 300);
  }

  getDateStringDBFromDate(date: Moment): string | null {
    // let formattedStartDate = moment(date).format('DD-MM-YYYY');
     const dataConvertita = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
     return dataConvertita;
   }
   
   getDateFromStringToSTringCalendar(date: string): string | null {
     let formattedStartDate = moment(date).format('DD/MM/YYYY');
     return formattedStartDate;
   }

  get effectiveClusterOption(): SelectItem[] {
    const isEdit = this.auditRuleConditionEditId && this.auditRuleConditionEditId > 0;
    return isEdit ? this.clusterOption : (this.clusterOptionActive || this.clusterOption);
  }

   closePopUpDialog(){
      this.isPopUp = false;
      this.closePopUp.emit(this.auditRuleObject);
      this.conditionObjectChanged.emit(this.auditRuleObject);
   }

   onChangeAcmRange(acmRange: SelectItem, ruleTable?: AuditRuleCondition) {
    if(acmRange){
      this.acm_value = null;
      this.acm_comparison_operator = null;
      this.fieldModel.acm_comparison_operator = null
      this.fieldModel.acm_value = null;
    }else{
      this.acm_max = null;
      this.acm_min = null;
      this.fieldModel.acm_max = null;
      this.fieldModel.acm_min = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-condition/audit-new-condition/audit-new-condition.component.ts